<template>
  <header
    class="absolute z-20 inset-x-0 top-0 md:relative h-14 sm:h-max dark:bg-[#212329] p-4 lg:p-5 w-full flex justify-between"
  >
    <slot></slot>
  </header>
</template>
